import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import WhyPractitionersSection from './components/WhyPractitionersSection';
import BenefitsSection from './components/BenefitsSection';
import ProgramsSection from './components/ProgramsSection';
import TestimonialSection from './components/TestimonialSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white font-sans text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <WhyPractitionersSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <ProgramsSection data-id="element-8" />
        <TestimonialSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}